import "@/App.css";
import { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CommodityProvider } from "@/context/CommodityContext";
import { isDataSite } from "@/lib/site";
import { dataSiteRoutes, flagshipRoutes, sharedRoutes } from "@/routes";

const TITLES = {
  "/": "Virtus Registry · The American Provenance Standard",
  "/market": "Market Data · Virtus Registry",
  "/pricing": "Pricing · Virtus Registry",
  "/registry": "The Registry · Virtus Registry",
  "/collection": "The Collection · Virtus Registry",
  "/about": "About · Virtus Registry",
  "/metals-desk": "The Metals Desk · Virtus Registry",
  "/vdr-rdi": "VDR-RDI Methodology · Virtus Registry",
  "/verify": "Verify an Asset · Virtus Registry",
  "/africa-news": "Africa News · Virtus Registry",
  "/terminal": "The Terminal · Virtus Registry",
  "/calendar": "Desk Calendar · Virtus Registry",
  "/wire": "The Provenance · Virtus Registry",
  "/wire/archive": "Archive · The Provenance · Virtus Registry",
  "/advisor": "VDR Trading Advisor · Virtus Registry",
  "/trade-center": "Trade Center · Virtus Registry",
  "/intelligence": "Intelligence · Virtus Registry",
  "/compliance": "US Compliance Desk · Virtus Registry",
  "/contact": "Contact · Virtus Registry",
  "/terms": "Terms · Virtus Registry",
};

function TitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = TITLES[pathname] || "Virtus Registry · The American Provenance Standard";
  }, [pathname]);
  return null;
}

function RouteFallback() {
  return (
    <div className="min-h-screen bg-bb-bg flex items-center justify-center" data-testid="route-loading">
      <div className="w-8 h-8 border-2 border-bb-gold/30 border-t-bb-gold rounded-full animate-spin" />
    </div>
  );
}

function App() {
  const dataSite = isDataSite();
  return (
    <AuthProvider>
      <CommodityProvider>
        <BrowserRouter>
          <TitleManager />
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              {dataSite ? dataSiteRoutes() : flagshipRoutes()}
              {sharedRoutes()}
            </Routes>
          </Suspense>
        </BrowserRouter>
      </CommodityProvider>
    </AuthProvider>
  );
}

export default App;
